import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Button, Snackbar } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";

import ContactDetailField from "../../../molecules/ContactDetailField";
import { useLocation } from "react-router-dom";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
// import QuotationFormDownload from "./download";
import CustomCheckbox from "../../../atoms/CustomCheckbox";
import DynamicText from "../../../molecules/DynamicText";
import PrintComponent from "../../PrintComponent";
import CrewInstructionDownload from "./download";
import moment from "moment";
import MySignatureCanvas from "../../../molecules/signature_canvas";

const CrewInstructionFormPage = () => {
  const [formContent, setFormContent] = useState({});
  const [formContentId, setFormContentId] = useState("");

  const [surveyData, setSurveyData] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");


  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);

  const [clientInd, setClientInd] = useState(-1);

  const [isSignCanvas, setSignCanvas] = useState(false);
  const [whichSign, setWhichSign] = useState("");


  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const updateContent = (data) => {
    setIsLoading(true);

    let media = [];
    let mediaInd = 0;
    formContent?.clients?.map((cl, ind) => {
      if (cl?.sign?.trim()?.length > 0) {
        media[mediaInd] = cl?.sign;
        mediaInd++;
      }

      return <></>;
    });

    const body = {
      formContentId: formContentId,
      content: data ? data : formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        setSnackbarMessage("Signature has been added successfully!");

        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
        setUploadText("Upload");
        setMediaKeysToSend([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }
        setUploadText("Upload");
        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    setMediaKeysToSend([]);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        for (let i = 0; i < res.data.data.content?.clients?.length; i++) {
          if (res.data.data.content?.clients?.[i]?.email == email) {
            setClientInd(i);
            i = res.data.data.content?.length;
          }
        }

        setIsLoading(false);
      })
      .catch((error) => {
        setIsValid(false);
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);




  const [uploadText, setUploadText] = useState("Upload");
  const [uploadText1, setUploadText1] = useState("Upload Sign");
  const [uploadText2, setUploadText2] = useState("Upload Sign");
  //
  const uploadFile = async (file) => {

    setIsLoading(true);

    if (whichSign == "move") setUploadText1("Uploading...");
    if (whichSign == "manager") setUploadText2("Uploading...");

    setUploadText("Uploading...");
    const fd = new FormData();
    fd.append("image", file);

    imageUploadClientPreview(fd, surveyId, formId, email, token)
      .then((res) => {
        let values = { ...formContent };

        if (whichSign == "move") values.moveCordinatorSign = res?.data?.data?.key;
        if (whichSign == "manager")
          values.packingManagerSign = res?.data?.data?.key;

        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setTimeout(() => {
          updateContent(values);
        }, 1500);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setUploadText1("Upload Sign");
        setUploadText2("Upload Sign");

        setIsLoading(false);
      });

  };



  return (
    <>
      {isValid ? (
        <PremiumPublicLayout
            title="Crew Instruction Document"
            hideBackButton={true}
            actions={
                <div className="d-flex gap-3">
                    {formContent?.clientSign?.trim()?.length == 0 && (
                        <Button
                            variant="contained"
                            onClick={() => setSignCanvas(true)}
                            sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                        >
                            {uploadText}
                        </Button>
                    )}

                    <Button
                        variant="contained"
                        onClick={() => {
                            if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                                const tempTitle = document.title;
                            const newTitle = `Crew-Instruction-${formContent?.customerName || 'Document'}-${moment().format("DD.MM.YYYY")}`;
                            document.title = newTitle;

                            // Standardized delay for print and title restoration
                            setTimeout(() => {
                                window.print();
                                setTimeout(() => {
                                    document.title = tempTitle;
                                }, 2000);
                            }, 500);
                        }}
                        disabled={isLoading}
                        sx={{ 
                            textTransform: "none", 
                            borderRadius: "var(--radius-md)", 
                            padding: "10px 24px",
                            fontWeight: 700,
                            backgroundColor: "var(--text-main)",
                            boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                            '&:hover': { backgroundColor: '#000' }
                        }}
                        startIcon={<DescriptionIcon />}
                    >
                        Save as PDF
                    </Button>
                </div>
            }
        >
              <PremiumCard sx={{ marginBottom: "32px" }}>
                 <SectionHeader title="Job Details" icon={<AssignmentIcon />} />
                 <Row>
                     <Col md={6}>
                        <ContactDetailField
                            label="File Ref"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"150px"}
                            value={formContent?.fielRef}
                            disabled={true}
                        />
                         <ContactDetailField
                            label="Customer Name"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"150px"}
                            value={formContent?.customerName}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.customerName = e.target.value;
                            setFormContent(values);
                            }}
                        />
                         <ContactDetailField
                            label="Organization"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"150px"}
                            value={formContent?.organization}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.organization = e.target.value;
                            setFormContent(values);
                            }}
                        />
                        <ContactDetailField
                            label="Document Date"
                            isEdit={isEdit}
                            type="date"
                            minWidth={"150px"}
                            value={formContent?.documentdate}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.documentdate = e.target.value;
                            setFormContent(values);
                            }}
                        />
                     </Col>
                     <Col md={6}>
                        <ContactDetailField
                            label="Origin Address"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"150px"}
                            value={formContent?.originAddress}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.originAddress = e.target.value;
                            setFormContent(values);
                            }}
                        />
                        <ContactDetailField
                            label="Destination Address"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"150px"}
                            value={formContent?.destinationAddress}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.destinationAddress = e.target.value;
                            setFormContent(values);
                            }}
                        />
                         <ContactDetailField
                            label="Date"
                            isEdit={isEdit}
                            type="date"
                            minWidth={"150px"}
                            value={formContent?.date}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.date = e.target.value;
                            setFormContent(values);
                            }}
                        />
                     </Col>
                 </Row>
             </PremiumCard>

              <PremiumCard sx={{ marginBottom: "32px" }}>
                 <SectionHeader title="Description of Services" icon={<DescriptionIcon />} />
                 <Row>
                    {[
                        { id: "preMoveSurvey", label: "Pre Move Survey", value: "preMoveSurcey" },
                        { id: "localMove", label: "Local Move", value: "localMove" },
                        { id: "InternationalMove", label: "International Move", value: "internationalMove" },
                        { id: "Road", label: "Road", value: "road" },
                        { id: "Assembling", label: "Assembling", value: "assembling" },
                        { id: "debrisRemoval", label: "Debris Removal", value: "debrisRemoval" },
                        { id: "Payments", label: "Payments", value: "payments" },
                        { id: "Documents", label: "Documents", value: "documents" },
                        { id: "Air", label: "Air", value: "air" },
                        { id: "Unloading", label: "Unloading", value: "unloading" },
                        { id: "Loading", label: "Loading", value: "loading" },
                        { id: "Invoice", label: "Invoice", value: "invoice" },
                        { id: "Delivery", label: "Delivery", value: "delivery" },
                        { id: "Sea", label: "Sea", value: "sea" },
                        { id: "Packing", label: "Packing", value: "packing" },
                        { id: "Unpacking", label: "Unpacking", value: "unpacking" }
                    ].map((item, index) => (
                        <Col md={3} sm={6} key={index} className="mb-3">
                            <CustomCheckbox
                                style="mb-0"
                                id={item.id}
                                label={item.label}
                                value={formContent?.[item.value]}
                                onChange={(e) => {
                                let values = { ...formContent };
                                values[item.value] = e.target.checked;
                                setFormContent(values);
                                }}
                                path={""}
                                disabled={!isEdit ? true : false}
                            />
                        </Col>
                    ))}
                 </Row>
             </PremiumCard>

              <PremiumCard sx={{ marginBottom: "32px" }}>
                 <SectionHeader title="Schedule" icon={<AccessTimeIcon />} />
                 <Row>
                     <Col md={6}>
                        <ContactDetailField
                            label="Job Start Date"
                            isEdit={isEdit}
                            type="date"
                            value={formContent?.jobStartDate}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.jobStartDate = e.target.value;
                                setFormContent(values);
                            }}
                            minWidth={"150px"}
                        />
                         <ContactDetailField
                            label="Job End Date"
                            isEdit={isEdit}
                            type="date"
                            value={formContent?.jobEndDate}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.jobEndDate = e.target.value;
                                setFormContent(values);
                            }}
                            minWidth={"150px"}
                        />
                     </Col>
                     <Col md={6}>
                        <ContactDetailField
                            label="Job Start Time"
                            isEdit={isEdit}
                            type="time"
                            value={formContent?.jobStartTime}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.jobStartTime = e.target.value;
                                setFormContent(values);
                            }}
                            minWidth={"150px"}
                        />
                         <ContactDetailField
                            label="Job End Time"
                            isEdit={isEdit}
                            type="time"
                            value={formContent?.jobEndTime}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.jobEndTime = e.target.value;
                                setFormContent(values);
                            }}
                            minWidth={"150px"}
                        />
                     </Col>
                 </Row>
             </PremiumCard>

              <PremiumCard sx={{ marginBottom: "32px" }}>
                 <SectionHeader title="Exclusions" icon={<DoNotDisturbIcon />} />
                 <Row>
                     <Col md={12}>
                        <DynamicText
                            label="Standard Exclusions:"
                            textAreaLabel="Standard Exclusions"
                            isEdit={isEdit}
                            value={formContent?.exclusions}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.exclusions = e.target.value;
                            setFormContent(values);
                            }}
                        />
                     </Col>
                 </Row>
             </PremiumCard>
            
            <PremiumCard>
                <SectionHeader title="Signatures" icon={<DescriptionIcon />} />
                <Row>
                     <Col sm={6} className="text-center">
                         <div
                            style={{ height: "90px" }}
                            className="d-flex justify-content-center align-items-end"
                        >
                            {formContent?.moveCordinatorSign?.trim()?.length == 0 ? (
                                <div className="d-flex justify-content-center align-items-end">
                                    <label
                                        htmlFor="uploadSignMove"
                                         className="btn btn-primary btn-sm no-print"
                                         style={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
                                    >
                                        {uploadText1}
                                    </label>
                                    <input
                                        type="button"
                                        hidden
                                        id="uploadSignMove"
                                        name="uploadSignMove"
                                        onClick={() => {
                                        setWhichSign("move");
                                        setSignCanvas(true)
                                        }}
                                    />
                                </div>
                            ) : (
                                <img
                                src={`${Bucket}${formContent?.moveCordinatorSign}`}
                                height={80}
                                width={200}
                                 style={{maxHeight: '80px', maxWidth: '100%', objectFit: 'contain'}}
                                />
                            )}
                        </div>
                         <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                         <p className="my-1">
                            <b>{"Move Coordinator"}</b>
                        </p>
                    </Col>
                     <Col sm={6} className="text-center">
                         <div
                            style={{ height: "90px" }}
                            className="d-flex justify-content-center align-items-end"
                        >
                            {formContent?.packingManagerSign?.trim()?.length == 0 ? (
                                <div className="d-flex justify-content-center align-items-end">
                                    <label
                                        htmlFor="uploadSignManager"
                                        className="btn btn-primary btn-sm no-print"
                                         style={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
                                    >
                                        {uploadText2}
                                    </label>
                                    <input
                                        type="button"
                                        hidden
                                        id="uploadSignManager"
                                        name="uploadSignManager"
                                        onClick={() => {
                                        setWhichSign("manager");
                                        setSignCanvas(true);
                                        }}
                                    />
                                </div>
                            ) : (
                                <img
                                src={`${Bucket}${formContent.packingManagerSign}`}
                                height={80}
                                width={200}
                                 style={{maxHeight: '80px', maxWidth: '100%', objectFit: 'contain'}}
                                />
                            )}
                        </div>
                        <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                        <p className="my-1">
                            <b>{"Packing Manager"}</b>
                        </p>
                    </Col>
                </Row>
            </PremiumCard>

        </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      <PrintComponent>
        <CrewInstructionDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      {/* Add signature Modal */}
      {isSignCanvas && (
        <MySignatureCanvas
          open={isSignCanvas}
          onClose={() => {
            setSignCanvas(false);
          }}
          onSuccess={(file) => {
            if (!isLoading) uploadFile(file);
          }}
        />
      )}
    </>
  );
};

export default CrewInstructionFormPage;
